import React from 'react';

/**
 * Chakana — the Inca Cross / Andean Cross
 * Sacred symbol representing the connection between the three worlds:
 * Hanan Pacha (upper), Kay Pacha (this world), Ukhu Pacha (inner).
 * Precisely proportioned stepped cross with hollow center diamond.
 */
const ChakanaIcon = ({ size = 24, color = 'currentColor', style = {}, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d={`
        M 44,4 L 56,4 L 56,14 L 61,14 L 61,24 L 66,24 L 66,34
        L 76,34 L 76,39 L 86,39 L 86,44 L 96,44 L 96,56
        L 86,56 L 86,61 L 76,61 L 76,66
        L 66,66 L 66,76 L 61,76 L 61,86 L 56,86 L 56,96
        L 44,96 L 44,86 L 39,86 L 39,76 L 34,76
        L 34,66 L 24,66 L 24,61 L 14,61 L 14,56 L 4,56
        L 4,44 L 14,44 L 14,39 L 24,39 L 24,34
        L 34,34 L 34,24 L 39,24 L 39,14 L 44,14 Z
        M 50,42 L 42,50 L 50,58 L 58,50 Z
      `}
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default ChakanaIcon;
